export default __webpack_public_path__ + "static/media/Freetakistan.87c4ea7b.png";